import type { FeatureConfig } from '@/core/registry'
import datasetsRoutes from './routes'
import datasetsLocales from './locales'
import { DATASET_PERMISSIONS } from './constants/permissions.constants'

const config: FeatureConfig = {
  routes: datasetsRoutes,
  locales: { ns: 'datasets', resources: datasetsLocales },
  permissions: DATASET_PERMISSIONS,
}

export default config
